import { HttpClient, HttpHeaders } from "@angular/common/http";
// Angular stuff
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Permission } from "@core_n/common/enums";
import { userSettings } from "@core_n/common/settings";
import { Observable } from "rxjs";
import { AppConfig } from "./app.config";
import { SessionService } from "./common/session.service";
import { EnvironmentNames } from "./models/app-config.model";

interface IdentifyResponse {
  username: string;
  role: string;
  scope: string;
}

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private configService: AppConfig,
    private session: SessionService,
    private http: HttpClient
  ) {}
  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): | boolean | UrlTree| Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.session.isLoggedIn()) {
      return true;
    } else {
      return this.configService.waitUntil().then(() => {
        switch (this.configService.environmentName) {
          case "aws":
            this.session.showLoginPage();
            return false;
          case "sky":
            return this.fetchIdentity();
        }
      });
    }
  }

  private fetchIdentity() {
    const url =
      AppConfig.settings.videoAddress.baseURL +
      AppConfig.settings.videoAddress.tokenAddress;

    const headers = new HttpHeaders({
      "Connect-Type": "application/json",
    });
    return this.http
      .get<IdentifyResponse>(url, { headers })
      .toPromise()
      .then((data) => {
        this.handleIdentityResponse(data);
        return true;
      })
      .catch((error) => {
        console.error(`[Auth Guard][${EnvironmentNames.Sky}] get identity failed, try switch environment to ${(EnvironmentNames.Aws)}`);
        return false;
      });
  }

  private handleIdentityResponse(response: IdentifyResponse) {
    // this.videoMngrService.setToken(Response.access_token);
    const perms = JSON.parse(response.role);

    this.session.setUserViewPriv(perms);
    userSettings.canSeeAi = perms.canSeeAi;
    userSettings.canSeeSolo = perms.canSeeSol;
    userSettings.isCameraAdmin = perms.cameraAdmin;
    userSettings.setViewPerms();
    if (perms.uid && perms.pid)
      // this.alertMngr.authenticate(perms.uid, perms.pid);
      console.warn("should authanticate alertmngr");
    else console.warn("did not get alertMngr (AWS) creds...");

    this.session.setUserLoggedIn(true, response.username, Permission.ADMIN, "");
    this.session.setLoggedIn(response.username, Permission.ADMIN);
  }
}
